export default __webpack_public_path__ + "static/testimonial-pedro-ee784e6e6c859544e405f6e0a2a6f656.jpg";